// Update a household application if it is found in householdApplications array.
export default function updateLocalApplication({ state }, { applicationId, updates }) {
  const application = state.select(['householdApplications', ({ id }) => id === applicationId]);
  if (application.exists()) {
    application.merge(updates);
    state.commit();
  }
}
